import { TBaseInformationAboutResponse } from '@commonTypes/basic';
import { URLS } from '../../constants/urls';
import axiosInstance from '../../core/interceptor';
import React, { FC, useCallback, useEffect, useState } from 'react';
import AssignTasksModal from '../AssignTasksModal/index';
import {
  TAssignTask,
  TAssignTaskRequestParams,
  TAssignTaskResponse,
  TMember,
  TMemberOption,
  TSaveFormData,
  TTask,
  TTaskOption,
  TTaskSave
} from '../AssignTasksModal/types';
import { AxiosResponse } from 'axios';

type TProps = {
  accountId: string;
  url: string;
  entityType: number; // TODO Add type from Alerts feature
  entitiesIds: { itemId: string; accountId: string }[];
  onClose: () => void;
  onMessageShow: (value: string) => void;
  onErrorShow: (value: TBaseInformationAboutResponse) => void;
};

const AssignTasksModalNativeWrapper: FC<TProps> = ({
  accountId,
  entitiesIds,
  entityType,
  url,
  onClose,
  onErrorShow,
  onMessageShow
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<TAssignTask>(null);
  const fetchData = () => {
    setIsLoading(true);

    axiosInstance
      .post(`${url}${URLS.ASSIGN_TASKS}`, { entityType, accountId })
      .then((response: AxiosResponse<TAssignTaskResponse>) => {
        setData(response.data.createdObject);
      })
      .catch((e) => {
        onErrorShow(e);
        onClose();
      })
      .finally(() => setIsLoading(false));
  };

  const handleAssign = useCallback(
    (data: TSaveFormData) => {
      setIsLoading(true);

      const idsCollection = entitiesIds.reduce((acc, item) => {
        acc[item.itemId] = item.accountId
        return acc;
      }, {});

      const requestData: TAssignTaskRequestParams = {
        accountId,
        entityType,
        ids: idsCollection,
        comments: data.comments,
        tasks: data.defaultTasks.reduce((acc: TTaskSave[], task: TTask) => {
          const values: TTaskSave[] = task.values.map((item: TTaskOption) => ({
            assignType: task.assignType,
            value: item
          }));

          return [...acc, ...values];
        }, []),
        userIds: data.defaultTeamMembers.reduce((acc: string[], member: TMember) => {
          return [...acc, ...member.values.map((item: TMemberOption) => item.id)];
        }, [])
      };

      axiosInstance
        .post(`${url}${URLS.ASSIGN_TASKS_ASSIGN}`, { ...requestData })
        .then((response: AxiosResponse<TBaseInformationAboutResponse>) => {
          onClose();
        })
        .catch((e) => {
          onErrorShow(e);
          onClose();
        })
        .finally(() => setIsLoading(false));
    },
    [accountId, entitiesIds, entityType]
  );

  useEffect(() => fetchData(), [accountId, entityType]);

  return (
    <AssignTasksModal
      data={data}
      count={entitiesIds.length}
      isLoading={isLoading}
      onClose={onClose}
      onSave={handleAssign}
    />
  );
};

export default AssignTasksModalNativeWrapper;
